import script from "./inventoryWorksites.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryWorksites.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryWorksites.vue?vue&type=style&index=0&id=5bc22b82&lang=scss"
import "./inventoryWorksites.vue?vue&type=style&index=1&id=5bc22b82&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc22b82"]])

export default __exports__